import { render, staticRenderFns } from "./SnagListPage.vue?vue&type=template&id=3d0a709b&"
import script from "./SnagListPage.vue?vue&type=script&lang=js&"
export * from "./SnagListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports